export {
    PinBlueIcon as TaskIcon, 
    PinBlue, PinBlueActiveIcon, PinRed, PinYellow, PinGreen,
    PinGray,
    UserOnMapIcon,
    AssigneeIcon,
    AssigneeHoverIcon,
    AssigneeInactiveIcon,
    AssigneeInactiveHoverIcon,
    CircleBlue,
};

function PinBlueIcon() {
    const Class = PinBlueIcon._ = PinBlueIcon._ || M.Icon.extend( {
        iconUrl: 'images/markers/pin-blue.png',
        shadowUrl: 'lib/mapsurfer/images/marker-shadow.png',
        iconSize: new M.Point( 40, 52 )
    } );

    return new Class();
}

function PinBlue() {
    const Class = M.PinBlue = M.PinBlue || M.Cluster.Icon.extend( { 
        options: {
            image: 'https://tariffs.dev.geo4.pro/dictionary/icons/19/view', 
            iconSize: new M.Point(32, 32), 
            iconAnchor: new M.Point(32, 16), 
            popupAnchor: new M.Point(0, -8), 
            labelColor: '#ffffff',
            className: 'pin pin-blue'
        }
    } );    

    return Class;
}

function PinGreen() {
    const Class = M.PinGreen = M.PinGreen || M.Cluster.Icon.extend( { 
        options: {
            image: 'https://tariffs.dev.geo4.pro/dictionary/icons/19/view', 
            iconSize: new M.Point(32, 32), 
            iconAnchor: new M.Point(32, 32), 
            popupAnchor: new M.Point(0, -8), 
            labelColor: '#ffffff',
            className: 'pin pin-green'
        }
    } );    

    return Class;
}

function PinYellow() {
    const Class = PinYellow._ = PinYellow._ || M.Icon.extend( {
        iconUrl: 'images/markers/pin-yellow.png',
        shadowUrl: 'lib/mapsurfer/images/marker-shadow.png',
        iconSize: new M.Point( 40, 52 )
    } );

    return new Class();
}

function PinRed() {
    const Class = M.PinRed = M.PinRed || M.Cluster.Icon.extend( { 
        options: {
            image: 'https://tariffs.dev.geo4.pro/dictionary/icons/19/view', 
            iconSize: new M.Point(32, 32), 
            iconAnchor: new M.Point(32, 32), 
            popupAnchor: new M.Point(0, -8), 
            labelColor: '#ffffff',
            className: 'pin pin-red'
        }
    } );    

    return Class;
}

function PinBlueActiveIcon() {
    const Class = PinBlueActiveIcon._ = PinBlueActiveIcon._ || M.Icon.extend( {
        iconUrl: 'images/markers/pin-blue-active.png',
        shadowUrl: 'lib/mapsurfer/images/marker-shadow.png',
        iconSize: new M.Point( 40, 52 )
    } );

    return new Class();
}

function PinGray() {
    const Class = M.PinGray = M.PinGray || M.Cluster.Icon.extend( { 
        options: {
            image: 'https://tariffs.dev.geo4.pro/dictionary/icons/19/view', 
            iconSize: new M.Point(32, 32), 
            iconAnchor: new M.Point(32, 32), 
            popupAnchor: new M.Point(0, -8), 
            labelColor: '#ffffff',
            className: 'pin pin-gray'
        }
    } );    

    return Class;
}

function UserOnMapIcon() {
    const Class = UserOnMapIcon._ = UserOnMapIcon._ || M.Icon.extend( {
        iconUrl: 'images/markers/user-blue.png',
        shadowUrl: 'lib/mapsurfer/images/marker-shadow.png',
        iconSize: new M.Point( 20, 33 )
    } );

    return new Class();
}

function AssigneeIcon() {
    const Class = AssigneeIcon._ = AssigneeIcon._ || M.Icon.extend( {
        iconUrl: 'images/markers/user-green.png',
        shadowUrl: 'lib/mapsurfer/images/marker-shadow.png',
        iconSize: new M.Point( 20, 33 )
    } );

    return new Class();
}

function AssigneeHoverIcon() {
    const Class = AssigneeHoverIcon._ = AssigneeHoverIcon._ || M.Icon.extend( {
        iconUrl: 'images/markers/user-green-hover.png',
        shadowUrl: 'lib/mapsurfer/images/marker-shadow.png',
        iconSize: new M.Point( 20, 33 )
    } );

    return new Class();
}

function AssigneeInactiveIcon() {
    const Class = AssigneeInactiveIcon._ = AssigneeInactiveIcon._ || M.Icon.extend( {
        iconUrl: 'images/markers/user-gray.png',
        shadowUrl: 'lib/mapsurfer/images/marker-shadow.png',
        iconSize: new M.Point( 20, 33 )
    } );

    return new Class();
}

function AssigneeInactiveHoverIcon() {
    const Class = AssigneeInactiveHoverIcon._ = AssigneeInactiveHoverIcon._ || M.Icon.extend( {
        iconUrl: 'images/markers/user-gray-hover.png',
        shadowUrl: 'lib/mapsurfer/images/marker-shadow.png',
        iconSize: new M.Point( 20, 33 )
    } );

    return new Class();
}

function CircleBlue() {
    const Class = M.CircleBlue = M.CircleBlue || M.Cluster.Icon.extend( { // создаем иконку для кластеров
        options: {
            image: "https://tariffs.dev.geo4.pro/dictionary/icons/19/view", // ссылка на изображение
            iconSize: new M.Point(32, 32), // размер изображения
            iconAnchor: new M.Point(32, 32), // смещение для отображения
            popupAnchor: new M.Point(0, -8), // смещение для popup
            labelColor: '#ffffff'
        }
    } );

    return Class;
}    



// WEBPACK FOOTER //
// ./src/js/view/map.icons.js